import { useQuery } from "@tanstack/react-query";
import api, { inr, num } from "@/lib/api";
import { PageHeader, Panel, Loading, StatCard, CHART_COLORS } from "@/components/kit";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Cell } from "recharts";
import { Trophy, Layers, RotateCcw, Coins } from "lucide-react";

export default function Milestone() {
  const { data, isLoading } = useQuery({
    queryKey: ["dash-milestone"],
    queryFn: async () => (await api.get("/dashboard/milestone")).data,
  });
  if (isLoading || !data) return <Loading label="Loading milestone dashboard…" />;
  const k = data.kpis;

  return (
    <div>
      <PageHeader title="Milestone Dashboard" subtitle="Block achievement vs monthly fallback for milestone schemes" />
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
        <StatCard testid="ms-kpi-block" label="Block Achievers" value={num(k.block_achievers)} icon={Trophy} tone="violet" sub={`${num(k.total_dealers)} dealers evaluated`} />
        <StatCard testid="ms-kpi-fallback" label="Fallback Dealers" value={num(k.fallback_dealers)} icon={RotateCcw} tone="gold" />
        <StatCard testid="ms-kpi-block-payout" label="Block Payout" value={inr(k.block_payout)} icon={Coins} tone="navy" />
        <StatCard testid="ms-kpi-fallback-payout" label="Fallback Payout" value={inr(k.fallback_payout)} icon={Layers} tone="emerald" />
      </div>

      <Panel testid="panel-block-dist" title="Completed Block Distribution" subtitle="Number of dealers by blocks achieved">
        <ResponsiveContainer width="100%" height={320}>
          <BarChart data={data.block_distribution} margin={{ left: 10 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#eef2f7" vertical={false} />
            <XAxis dataKey="blocks" tick={{ fontSize: 12, fill: "#334155" }} label={{ value: "Blocks", position: "insideBottom", offset: -3, fontSize: 11, fill: "#94a3b8" }} />
            <YAxis tick={{ fontSize: 11, fill: "#64748b" }} allowDecimals={false} />
            <Tooltip />
            <Bar dataKey="dealers" radius={[8, 8, 0, 0]} barSize={44}>
              {data.block_distribution.map((e, i) => <Cell key={i} fill={CHART_COLORS[i % CHART_COLORS.length]} />)}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      </Panel>
    </div>
  );
}
